import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { collectCell, getPercent } from '../../../../helpers/showDelta';

export const COLUMNS = (t) => [
    {
        label: t('search.comparison.searchAppearance.columns.searchAppearance'),
        key: 'searchappearance',
        data: 'searchappearance',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => (csvDownload ? data : <strong>{data}</strong>),
    },
    {
        label: t('search.comparison.searchAppearance.columns.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'impressions_delta',
        data: 'impressions_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload
                ? getPercent(item.impressions, item.impressionsPrior)
                : collectCell(item.impressions, item.impressionsPrior),
    },
    {
        label: t('search.comparison.searchAppearance.columns.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'clicks_delta',
        data: 'clicks_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload
                ? getPercent(item.clicks, item.clicksPrior)
                : collectCell(item.clicks, item.clicksPrior),
    },
    {
        label: t('search.comparison.searchAppearance.columns.position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'avgPosition_delta',
        data: 'avgPosition_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload
                ? getPercent(item.avgPosition, item.avgPositionPrior)
                : collectCell(item.avgPosition, item.avgPositionPrior),
    },
    {
        label: t('search.comparison.searchAppearance.columns.ctr'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.impressions;
            return csvDownload ? ctrValue : <strong>{numeral(ctrValue).format('0.00%')}</strong>;
        },
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'avgCTR_delta',
        data: 'avgCTR_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.impressions;
            return csvDownload
                ? getPercent(ctrValue, item.avgCTRPrior)
                : collectCell(ctrValue, item.avgCTRPrior);
        },
    },
];
